<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="false"
    [title]="'Another Job In Progress'"
    [noBow]="true">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'You have a partially completed job with unsynced data.'">
      </tidy-text>
    </tidy-row>

    <tidy-button
      [text]="'Go Back'"
      [action]="goToJobs.bind(this)"
      class="primary">
    </tidy-button>

    <tidy-button
      [text]="'Clear Data and Proceed Anyway'"
      [action]="clearStore.bind(this)"
      class="secondary">
    </tidy-button>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
